module.exports = __webpack_public_path__ + "static/media/dev-icon-2.2f7b4d40.svg";